import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { ConfirmationDialogData } from '@components/confirmation/1.0';
import { ButtonStyle } from '@constants/button/1.0';
import { MessageType } from '@constants/message/1.0';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor } from '@angular/common';
import { MessageComponent } from '../../message/1.0/message.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { ButtonComponent } from '../../button/1.0/button.component';

@Component({
  selector: 'txp-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    NgIf,
    MessageComponent,
    MatCheckbox,
    MatSlideToggle,
    NgFor,
    MatDialogActions,
    ButtonComponent,
  ],
})
export class ConfirmationComponent {
  buttonStyle = ButtonStyle;
  disableContinueBtn: boolean;
  isSaving: boolean;
  showError: boolean;
  messageType = MessageType;
  errorMessage: string;
  toggleStatus: boolean;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
  ) {
    dialogRef.disableClose = true;
    this.disableContinueBtn = data.checkbox ? true : false;
  }

  onAction(value: boolean) {
    if (value) {
      this.isSaving = true;
      this.showError = false;
      if (this.data.confirmObservable) {
        this.data.confirmObservable.subscribe({
          complete: () => {
            this.dialogRef.close(value);
          },
          error: (err: string) => {
            if (this.data.closeOnError) {
              this.dialogRef.close(new Error(err));
            }

            this.isSaving = false;
            this.showError = true;
            this.errorMessage = err;
          },
        });
      } else if (this.data.toggle) {
        this.dialogRef.close({ value: value, status: this.data.toggle.status });
      } else {
        this.dialogRef.close(value);
      }
    } else {
      return this.dialogRef.close(value);
    }
  }
}
